import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import type { IntercomConfig, Panel } from '@livepuls/types';
import { api } from '../lib/api.js';
import { Radio } from 'lucide-react';

/**
 * Bei Direkt-Aufruf von "/" zeigt die PWA die Liste aller Ports und lässt
 * den Nutzer auswählen, welches dieser Client repräsentiert. Über den
 * Admin wird üblicherweise direkt eine /panel/:id-URL geteilt; diese Liste
 * ist Fallback.
 */
export function PickerPage(): JSX.Element {
  const [config, setConfig] = useState<IntercomConfig | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    api
      .get<{ config: IntercomConfig | null }>('/api/v1/config/live')
      .then((res) => setConfig(res.config))
      .catch((err: Error) => setError(err.message));
  }, []);

  return (
    <div className="min-h-full flex flex-col items-center px-5 py-10 max-w-md mx-auto">
      <div className="flex items-center gap-3 mb-8">
        <span
          className="font-black italic tracking-tighter leading-none text-2xl select-none"
        >
          <span className="text-white">LIVE</span>
          <span
            className="text-transparent bg-clip-text"
            style={{ backgroundImage: 'linear-gradient(90deg, #ff0099 0%, #00f2ff 100%)' }}
          >
            PULS
          </span>
        </span>
        <div>
          <p className="text-xs text-text-mute uppercase tracking-widest">Intercom</p>
          <p className="text-xs text-text-mute">Wähle dieses Gerät</p>
        </div>
      </div>

      {error ? (
        <p className="text-err text-sm">{error}</p>
      ) : !config ? (
        <p className="text-text-dim text-sm">Lade Ports…</p>
      ) : config.panels.length === 0 ? (
        <div className="card p-5 text-center text-text-dim text-sm w-full">
          Es sind noch keine Ports angelegt. Lege im Admin (Port 5173)
          einen Port an und teile dann den /panel/:id-Link mit diesem Gerät.
        </div>
      ) : (
        <ul className="w-full space-y-2">
          {config.panels.map((p: Panel) => (
            <li key={p.id}>
              <Link
                to={p.kind === 'source' ? `/source/${p.id}` : `/panel/${p.id}`}
                className="card flex items-center gap-3 px-4 py-3 hover:border-accent transition"
              >
                <Radio size={16} className="text-accent" />
                <span className="flex-1 font-medium">{p.name}</span>
                <span className="text-xxs text-text-mute uppercase tracking-wider">
                  {p.kind === 'source'
                    ? 'Quelle'
                    : `${p.layout.filter((s) => s.buttonId).length}/${p.layout.length}`}
                </span>
              </Link>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
